module.exports = __webpack_public_path__ + "static/media/ic_list_selected_36px.b4034b37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_list_selected_36px.svg
// module id = 796
// module chunks = 0